import Vue from 'vue'
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import logger from '@/logger'
import objects from '@/objects'

export default {
  update(state, changes) {
    for (const key in changes) {
      state[key] = changes[key]
    }
  },
  addEntity(state, props) {
    logger.info(`⭐ Creating new ${props.target} ${props.name}`, props)
    Vue.set(state[`${props.target}sById`], props.id, objects.Entity.create(props))
  },
  updateEntity(state, props) {
    const id = props.id
    const targets = `${props.target}sById`
    const oldEntity = cloneDeep(state[targets][id])
    const process = oldEntity.process
    const changes = {}
    logger.diff(oldEntity, props)
    for (const key in props) {
      if (key.includes('.')) {
        set(changes, key, props[key])
      } else {
        changes[key] = props[key]
      }
    }
    state[targets][id] = Object.assign(oldEntity, changes)
    const newEntity = state[targets][id]
    if (props.lastResult && process !== 'QUEUED') {
      const diff = moment().diff(moment(newEntity.processStarted), 'seconds')
      const icon = newEntity.lastResult === 'SUCCESS' ? '✅' : '⛔'
      const result = newEntity.lastResult === 'SUCCESS' ? 'success' : 'fail'
      logger[result](`${icon} ${process} of ${props.target} "${newEntity.name}" completed with ${newEntity.lastResult} ⌛ ${diff} s`)
    }
  },
  removeEntity(state, props) {
    logger.info(`🔥 Removing ${props.target} ${props.name}`, props);
    Vue.delete(state[`${props.target}sById`], props.id)
  },
}
